module.exports = __webpack_public_path__ + "p.no2.1685aa2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/p.no2.jpg
// module id = +uaf
// module chunks = 0